<template>
  <v-app>
    <router-view></router-view> <!-- This is where your routed components will be displayed -->
  </v-app>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* Add any global styles here */
</style>
